import script from "./ReviewProjectQuestModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewProjectQuestModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewProjectQuestModal.vue?vue&type=style&index=0&id=7b7a6892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b7a6892"]])

export default __exports__